/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const DelayTypes = {
    linear: 'linear',
    exponential: 'exponential',
    incremental: 'incremental',
} as const;

export type DelayTypes = typeof DelayTypes[keyof typeof DelayTypes];

export interface RetryOptions {
    maxRetries?: number;
    retryOn: {
        [errorCode: number]: {
            delayType: DelayTypes;
            delay: number | Array<number>;
            retryAfterHeader?: string;
            shouldCheckRetryAfterHeader?: boolean;
            errorMessage?: Array<string>;
        };
    };
}
